module.exports = __webpack_public_path__ + "static/media/home2-slider-1.aa940ef4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-1.jpg
// module id = 1148
// module chunks = 33